import styles from "./Header.module.css"
import { Link } from "react-router-dom"
import icon from "../../assets/images/iconplaceholder.png"

const User =({user})=>{

if(user){
  return (
    <Link to="/profile" className={styles.userbtn} style={{ textDecoration: 'none' }}>
      <img src={user.profile_picture?user.profile_picture:icon} alt="icon" /> <p className={styles.useName}>{user.username }</p>
    </Link>
  );
}
}

export default User